module.exports = __webpack_public_path__ + "static/media/cobru_plantilla_envios.4b71dc95.xlsx";